import {Endpoints} from "../Endpoints";
import Backend from "../../Backend";

export default class Category
{
	constructor(token)
	{
		this.backend = new Backend(token);
	}

	all(callback)
	{
		this.backend.callBackend(`${Endpoints.categories.private}/all`, callback);
	}

	add(name, callback)
	{
		this.backend.callBackend(Endpoints.categories.private, callback, "POST", {name: name});
	}

	update(id, name, callback)
	{
		this.backend.callBackend(Endpoints.categories.private, callback, "PUT", {id: id, name: name});
	}

	remove(id, callback)
	{
		this.backend.callBackend(`${Endpoints.categories.private}/id/${id}`, callback, "DELETE");
	}
}